@if (!chartReady()) {
<div class="w-full relative">
  <div class="bg-white rounded rounded-xl h-[400px]">
    <chl-loader
      class="!absolute !top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
</div>
} @else {
<co-chart-card
  [chartHeader]="chartHeader()"
  [cssClass]="cssClass()"
  [filterOptions]="filterOptions()"
  [selectedFilters]="selectedFilters"
  (onFilterChange)="onDropdownChange()"
  [testResult]="testResult()"
>
  <div chart-content>
    @if (diagnosisChange().length || diagnosisUnchange().length) {

    <apx-chart
      [series]="chartOptions.series!"
      [chart]="chartOptions.chart!"
      [xaxis]="chartOptions.xaxis!"
      [stroke]="chartOptions.stroke!"
      [tooltip]="chartOptions.tooltip!"
      [dataLabels]="chartOptions.dataLabels!"
      [legend]="chartOptions.legend!"
      [markers]="chartOptions.markers!"
      [grid]="chartOptions.grid!"
      [yaxis]="chartOptions.yaxis!"
      [title]="chartOptions.title!"
    >
    </apx-chart>

    } @else {
    <div class="flex items-center justify-center">
      <span class="text-black-500 text-lg font-medium">{{"REPORTS.NO_DATA_FOUND" | translate}}</span>
    </div>
    }
  </div>
</co-chart-card>
}
